import { iFormConfigItem } from "../../../../core/formValidation";

export interface iValidationData {}

export const validationConfig: iFormConfigItem<iValidationData>[] = [];